import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";

import {
  MacroCategoriesTitles
} from "../../../constants/document_categories";

import { VaporTab } from "../../vapor";
import { useLocation } from "react-router-dom";

const MacroCategoryFilter = props => {
  const {
    handleGetDocumentsWithSearch,
    macroCategories
  } = props;

  const location = useLocation();
  const currentLink = useSelector(state => state.documentsWithSearch.currentLink);
  const [lastMacroSelected, setLastMacroSelected] = React.useState(null);

  const getTitle = macroTitle => {
    return MacroCategoriesTitles[macroTitle.toLowerCase()] || macroTitle;
  };

  useEffect(() => {
    /** serve per atterrare diretto sul filtro in base allo state dalla useNavigate esterna */
    if (!location.state || !location.state?.categoryFilter) return; 
    
    setLastMacroSelected(location.state.categoryFilter);
    handleGetDocumentsWithSearch({ additionalProps: { macrocategory: location.state.categoryFilter.label } });
  }, [location.state]);
  
  let macroActive = null;
  if (currentLink) {
    let url = new URL(currentLink);
    macroActive = url.searchParams.get("macrocategory");
  }

  const onChangeTab = (it) => {    
    setLastMacroSelected({ label: it.value, link: it.link });
    if (currentLink !== it.link) {
      if (it.value === "") {
        handleGetDocumentsWithSearch({reset: true});
      } else {
        handleGetDocumentsWithSearch({ additionalProps: { macrocategory: it.value } });
      }
    }
  };

  const createTabItems = () => {
    let items = [
      {
        content: (
          <div className={"macroTitle"}>
            <FormattedMessage id="generic.all" />
          </div>),
        value: ""
      }];
    if (macroCategories && macroCategories.links && macroCategories.links.length > 0) {
      macroCategories.links.forEach(el => {
        const element = {
          content: (
            <div className={"macroTitle"}>
              {getTitle(el.label)}{" "}{el.count}
            </div>),
          link: el._links.self.href,
          value: el.label
        };
        items.push(element);
      });
    } else {
      if (lastMacroSelected) {
        items.push({
          content: (
            <div className={"macroTitle"}>
              {lastMacroSelected.label}{" "}{0}
            </div>),
          link: lastMacroSelected.link,
          value: lastMacroSelected.label
        });
      }
    }
    return items;
  };
  return (
    <div className="macroCategoryFilter">
      <VaporTab
        itemsStyle={{ width: "fit-content" }}
        containerStyle={{ padding: "12px 20px" }}
        items={createTabItems()}
        onChange={onChangeTab}
        active={macroActive ? macroActive : ""}
        type={"secondary"} />
    </div>
  );
};
export default MacroCategoryFilter;
